import React, { useEffect, useState } from "react";

// Target: 31 August 2026, 09:15 IST (market open)
const TARGET = new Date("2026-08-31T09:15:00+05:30").getTime();

function pad(n) {
  return String(n).padStart(2, "0");
}

export default function Countdown({ compact = false }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  const diff = Math.max(0, TARGET - now);
  const d = Math.floor(diff / (1000 * 60 * 60 * 24));
  const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const m = Math.floor((diff / (1000 * 60)) % 60);
  const s = Math.floor((diff / 1000) % 60);

  const Cell = ({ value, label }) => (
    <div
      className={`flex flex-col items-center justify-center border border-[#D4D0C5] bg-[#F4F3ED] px-3 py-3 min-w-[68px] ${
        compact ? "" : "md:min-w-[88px] md:px-5 md:py-4"
      }`}
    >
      <span
        className={`font-mono-acc font-bold text-[#0A0A0A] tabular-nums ${
          compact ? "text-2xl" : "text-3xl md:text-5xl"
        }`}
        data-testid={`countdown-${label.toLowerCase()}`}
      >
        {pad(value)}
      </span>
      <span className="font-mono-acc text-[9px] md:text-[10px] tracking-[0.3em] text-[#4A4A4A] mt-1 uppercase">
        {label}
      </span>
    </div>
  );

  return (
    <div data-testid="countdown" className="inline-flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <span className="w-1.5 h-1.5 bg-[#D9381E] blink" />
        <span className="font-mono-acc text-[10px] tracking-[0.3em] uppercase text-[#4A4A4A]">
          Batch commences 31 Aug 2026 • 09:15 IST
        </span>
      </div>
      <div className="flex items-stretch gap-2">
        <Cell value={d} label="Days" />
        <Cell value={h} label="Hours" />
        <Cell value={m} label="Mins" />
        <Cell value={s} label="Secs" />
      </div>
    </div>
  );
}
